export function getResolvedPublishedDocumentPath(
  documentId: number,
  latestPublishedVersionId: number | null,
  shouldOpenInWord: boolean,
): string {
  const searchParams = new URLSearchParams();

  if (latestPublishedVersionId !== null) {
    searchParams.set("versionId", latestPublishedVersionId.toString());
  }

  if (shouldOpenInWord) {
    searchParams.set("open", "word");
  }

  const query = searchParams.toString();
  return `/documents/${documentId}${query ? `?${query}` : ""}`;
}

export function consumeWordLaunchIntent(
  searchParams: URLSearchParams,
): URLSearchParams {
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete("open");

  return nextSearchParams;
}
